import React, { useEffect, useState } from "react"; // added useEffect, useState
import { useTranslation } from "react-i18next";
import AudioPlayer from "../components/mediaplayers/AudioPlayer";
import { useFormContext } from "react-hook-form";
import { getMisc } from "../apiclients/streamsapi_bridge"; // added import
import { MDBInput } from "mdb-react-ui-kit";

const VMSettingsMain = ({ vmCode, vmid, greetingsInfo }) => {
  const { t } = useTranslation();
  const { busy, unavailable } = greetingsInfo ?? {};

  // --- added state for vmlformat (mirroring UserVoicemails) ---
  const [vmailformat, setVmailFormat] = useState({});
  const [vmailfmt, setVmailFmt] = useState(0);
  // ------------------------------------------------------------

  // --- added states for extension availability check (mirroring HGeneralSettings) ---
  const [autoext, setAutoext] = useState(false);
  const [checkAvailbility, setCheckAvailbility] = useState("");
  const [checkAvailbilityTxt, setCheckAvailbilityTxt] = useState("");
  const [extCheckFlag, setextCheckFlag] = useState(0);
  const [extensionFlag, setExtensionFlag] = useState(true);
  const [defaultExtension, setDefaultExtension] = useState(0);
  // -----------------------------------------------------------------------------------

  const {
    register,
    formState: { errors },
    setValue,
    watch,
    clearErrors,
    setError,
    getValues,
  } = useFormContext();

  // --- added: set defaultExtension once form value is loaded (mirroring HGeneralSettings) ---
  useEffect(() => {
    if (extensionFlag && getValues("extension") != 0) {
      setDefaultExtension(getValues("extension"));
      setExtensionFlag(false);
    }
  }, [extensionFlag, getValues("extension")]);
  // -------------------------------------------------------------------------------------------

  // --- added: check extension availability (mirroring HGeneralSettings) ---
  async function checkAvailability(e) {
    e.preventDefault();
    e.stopPropagation();
    setextCheckFlag(1);
    const response = await getMisc(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      { check_ext: parseInt(e.target.value) }
    );
    if (!response.json) {
      return;
    }
    const tdata = await response.json();
    if (!tdata) {
      window.alert(`info with id  not found`);
      return;
    }
    if (tdata.check_ext) {
      setCheckAvailbility(true);
      setError("extension", { message: "Extension is available" });
    } else {
      setCheckAvailbility(false);
      setError("extension", { message: "Extension is not available" });
    }
  }
  // -------------------------------------------------------------------------

  // --- added: fetch vmlformat options from API (mirroring UserVoicemails) ---
  useEffect(() => {
    async function fetchData() {
      const response = await getMisc(
        JSON.parse(sessionStorage.getItem("admin_session")).siteid,
        { misc: ["vmlformat"] }
      );
      if (!response.json) {
        const message = `An error has occured: ${response.statusText}`;
        return;
      }
      const tdata = await response.json();
      if (!tdata) {
        window.alert(`info with id not found`);
        return;
      }
      setVmailFormat(tdata.misc.vmlformat);
    }
    fetchData();
  }, []);

  // --- added: sync vmailfmt with form value on mount/watch ---
  useEffect(() => {
    const currentFmt = watch("vmlformat");
    if (currentFmt !== undefined) {
      setVmailFmt(currentFmt);
    }
  }, [watch("vmlformat")]);
  // --------------------------------------------------------------------------

  return (
    <>
      <div className="vtabHeightHunt pr-5">
        <div className="general-settings" id="voicemail">
          {t("Voicemail")}
        </div>
        <div className="margin-top mb__scroll__voicmain">

          {/* Name */}
          <div className="add-numbermain">
            <div className="tel-numbers">{t("Name")}</div>
            <div className="d-flex w-30">
              <div className="phoneselect w-100">
                <input
                  maxLength={20}
                  className="form-control"
                  {...register("name", {
                    required: "Name is required",
                  })}
                />
                {errors.name && (
                  <p className="text-danger">{errors.name.message}</p>
                )}
              </div>
            </div>
          </div>

          {/* Extension */}
          <div className="add-numbermain">
            <div className="tel-numbers">{t("extension")}</div>
            <div className="w-30">
              <MDBInput
                type="text"
                name="extension"
                className="w-100"
                maxLength={5}
                {...register("extension", {
                  setValueAs: (value) => Number(value),
                  required: "Extension is required",
                  minLength: {
                    value: 3,
                    message: "Extension must be at least 3 characters",
                  },
                  maxLength: {
                    value: 5,
                    message: "Extension must not exceed 5 characters",
                  },
                })}
                onKeyPress={(event) => {
                  if (!/[0-9]/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value !== "") {
                    setValue("extension", parseInt(value), { shouldDirty: true });
                    if (+value > 9989 && +value <= 9999) {
                      setCheckAvailbility(false);
                      setError("extension", {
                        message:
                          "Select an extension in the range of 100 to 9989 or 10000 to 99999.",
                      });
                      return;
                    }
                    if (value.length >= 3 && value.length <= 5) {
                      if (parseInt(defaultExtension) === parseInt(value)) {
                        clearErrors("extension");
                        setCheckAvailbility(true);
                      } else {
                        checkAvailability(e);
                      }
                    }
                  } else {
                    setValue("extension", "", { shouldDirty: true });
                    clearErrors("extension");
                    setCheckAvailbility(false);
                  }
                }}
              />
              {errors.extension && (
                <>
                  {!checkAvailbility && (
                    <>
                      <p className="text-danger">{errors.extension.message}</p>
                    </>
                  )}
                  {checkAvailbility && (
                    <p style={{ color: "Green" }} className="clr-red">
                      {errors.extension.message}
                    </p>
                  )}
                </>
              )}
            </div>
          </div>

          {/* Pin */}
          <div className="add-numbermain">
            <div className="tel-numbers">{t("Pin")}</div>
            <div className="d-flex w-30">
              <div className="phoneselect w-100">
                <input
                  onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key)) {
                      event.stopPropagation();
                      event.preventDefault();
                    }
                  }}
                  {...register("vmail_pin", {
                    setValueAs: (value) => Number(value),
                    pattern: {
                      value: "[0-9]*",
                      message: "Must be numeric",
                    },
                  })}
                  className="w-100 form-control"
                />
                {errors.vmail_pin && (
                  <p className="text-danger">{errors.vmail_pin?.message}</p>
                )}
              </div>
            </div>
          </div>

          {/* Unavailable Greeting */}
          <div className="add-numbermain add-numbermain-small align-items-start">
            <div>
              <div className="tel-numbers">{t("unavaliableGreeting")}</div>
            </div>
            <AudioPlayer
              uniqueId={vmid}
              greetingType={unavailable?.greeting_type ?? 1}
              greetingId={unavailable?.greeting_id ?? 0}
              fileName={unavailable?.filename ?? ""}
              title={t("VoicemailUnavailableGreeting")}
              greetingMode={unavailable?.filename ?? "" !== "" ? 1 : 2}
              greetingTitle={unavailable?.title ?? ""}
              greetingObject={unavailable ?? null}
              shareVMFlag = {true}
            />
          </div>

          {/* Busy Greeting */}
          {/* <div className="add-numbermain add-numbermain-small align-items-start">
            <div>
              <div className="tel-numbers">{t("busyGreeting")}</div>
            </div>
            <AudioPlayer
              uniqueId={vmCode}
              greetingType={busy?.greeting_type ?? 2}
              greetingId={busy?.greeting_id ?? 0}
              fileName={busy?.filename ?? ""}
              title={t("VoicemailBusyGreeting")}
              greetingMode={busy?.filename ?? "" !== "" ? 1 : 2}
              greetingTitle={busy?.title ?? ""}
              greetingObject={busy ?? null}
            />
          </div> */}

          {/* Include Transcript */}
          <div className="add-numbermain">
            <div className="tel-numbers">
              {t("include_Transcript")}
              <br />
              <span className="phrecording text-secondary">
                {t("vmail_copy_trans_text")}
              </span>
            </div>
            <div className="d-flex">
              <div className="phoneselect">
                <div className="phoneselect">
                  <label className="switch">
                    <input
                      className="form-control"
                      {...register("email_transcript")}
                      type="checkbox"
                    />
                    <span className="slider round"></span>
                  </label>
                </div>
              </div>
            </div>
          </div>

          {/* Email Notifications */}
          <div className="add-numbermain">
            <div className="tel-numbers w-35">
              <label>{t("email_notif")}</label>
            </div>
            <div>
              <div className="phoneselect">
                <label className="switch">
                  <input
                    className="form-control"
                    id="vmmailnotify"
                    checked={watch("email_notify")}
                    type="checkbox"
                    onChange={(e) => {
                      e.stopPropagation();
                      e.preventDefault();
                      setValue("email_notify", e.target.checked, {
                        shouldDirty: true,
                      });
                      clearErrors("email_notify");
                    }}
                  />
                  <span className="slider round"></span>
                </label>
              </div>
              <div>
                {errors.email_notify && (
                  <p className="text-danger">{errors.email_notify?.message}</p>
                )}
              </div>
            </div>
          </div>

          {watch("email_notify") && (
            <>
              {/* Email Address */}
              <div className="add-numbermain">
                <div className="tel-numbers">
                  {t("email_address")}
                  <br />
                  <span className="phrecording text-secondary">
                    {t("vmail_copy_email_text")}
                  </span>
                </div>
                <div className="d-flex w-30">
                  <div className="phoneselect w-100">
                    <input
                      {...register("email_address", {
                        onChange: (e) => {
                          clearErrors("email_notify");
                        },
                      })}
                      placeholder="Enter Email Address"
                      className="w-100 form-control"
                    />
                    {errors.email_address && (
                      <p className="text-danger">
                        {errors.email_address.message}
                      </p>
                    )}
                  </div>
                </div>
              </div>

              {/* Delete After Sending Message */}
              <div className="add-numbermain">
                <div className="tel-numbers">
                  {t("del_send_message")}
                  <br />
                </div>
                <div className="d-flex">
                  <div className="phoneselect">
                    <div className="phoneselect">
                      <label className="switch">
                        <input
                          className="form-control"
                          type="checkbox"
                          {...register("vmail_delete")}
                        />
                        <span className="slider round"></span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              {/* Email Copy to All Members */}
               <div className="add-numbermain">
                <div className="tel-numbers">
                  {t("email_copy_to_all_mem")}
                  <br />
                </div>
                <div className="d-flex">
                  <div className="phoneselect">
                    <div className="phoneselect">
                      <label className="switch">
                        <input
                          className="form-control"
                          {...register("email_to_members", {
                            onChange: (e) => clearErrors("email_notify"),
                          })}
                          type="checkbox"
                        />
                        <span className="slider round"></span>
                      </label>
                    </div>
                  </div>
                </div>
              </div> 

              {/* Email Copy to All Supervisors */}
              {/* <div className="add-numbermain">
                <div className="tel-numbers">
                  {t("email_copy_to_all_sup")}
                  <br />
                </div>
                <div className="d-flex">
                  <div className="phoneselect">
                    <div className="phoneselect">
                      <label className="switch">
                        <input
                          className="form-control"
                          {...register("email_to_sup", {
                            onChange: (e) => clearErrors("email_notify"),
                          })}
                          type="checkbox"
                        />
                        <span className="slider round"></span>
                      </label>
                    </div>
                  </div>
                </div>
              </div> */}
            </>
          )}

          {/* VoiceMailFormat — mirrored from UserVoicemails */}
          {/* <div className="add-numbermain">
            <div className="tel-numbers">{t("VoiceMailFormat")}</div>
            <div className="phoneselect w-30">
              <select
                className="form-control form-select selectname w-100"
                value={vmailfmt}
                onChange={(e) => {
                  e.preventDefault();
                  setValue("vmlformat", parseInt(e.target.value), {
                    shouldDirty: true,
                  });
                  setVmailFmt(parseInt(e.target.value));
                }}
              >
                {vmailformat &&
                  Object.entries(vmailformat).map(([key, value]) => (
                    <option key={key} value={key}>
                      {value}
                    </option>
                  ))}
              </select>
              {errors?.vmlformat && (
                <p className="text-danger">{errors?.vmlformat?.message}</p>
              )}
            </div>
          </div> */}

        </div>
      </div>
    </>
  );
};

export default VMSettingsMain;